// Import model
import { ExternalLink } from '../models/ExternalLink';

// Import base class serializer
import { EntityOwnedModelSerializer } from './EntityOwnedModelSerializer';

// Import dependency types (models and enums used in properties)
import { SfExternalLink } from '../models/SfExternalLink';

// Import dependency serializers (for complex types)
import { SfExternalLinkSerializer } from './SfExternalLinkSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ExternalLink - handles JSON serialization and deserialization with type validation
 */
export class ExternalLinkSerializer {
  /**
   * Deserializes a JSON string into a ExternalLink instance
   */
  static deserialize(json: string): ExternalLink {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ExternalLink instance
   */
  static fromObject(obj: any): ExternalLink {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ExternalLink');
    }


    const instance: ExternalLink = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      externalId: obj['externalId'] as string | undefined,
      properties: obj['Properties'] ? SfExternalLinkSerializer.fromObject(obj['Properties']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ExternalLink instances
   */
  static deserializeArray(json: string): ExternalLink[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ExternalLink instance to a JSON string
   */
  static serialize(instance: ExternalLink): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ExternalLink instance to a plain object
   */
  static toObject(instance: ExternalLink): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'externalId': instance.externalId,
      'Properties': instance.properties ? SfExternalLinkSerializer.toObject(instance.properties) : undefined,
    };
  }

  /**
   * Serializes an array of ExternalLink instances to a JSON string
   */
  static serializeArray(instances: ExternalLink[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
